export default "__VITE_ASSET__Dw0lhkyS__"